import {
  SET_LBO_DASHBOARD,
  SET_DCF_ANALYSIS,
  SET_DEBTPANEL,
  SET_DCF_VALUATION,
} from "./mutations";

const initialState = {
  currentLBODashboard: null,
  dealDCFAnalysis: null,
  debtPanel: null,
  dealDCFValuation: null,
};

const dealOfferReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_LBO_DASHBOARD:
      return { ...state, currentLBODashboard: payload };
    
    case SET_DCF_ANALYSIS:
      return { ...state, dealDCFAnalysis: payload };
      
    case SET_DEBTPANEL:
      return { ...state, debtPanel: payload };

    case SET_DCF_VALUATION:
      return { ...state, dealDCFValuation: payload };
      
    default:
      return state;
  }
};

export default dealOfferReducer;
